import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const TaxonomyImportScreen = lazy(
  () => import('~/features/item-setup/pages/taxonomy-import-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/taxonomy')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <TaxonomyImportScreen />
    </Suspense>
  ),
});
